import * as React from "react";
import {useEffect} from "react";
import {css, Theme, useTheme} from "@emotion/react";
import styled from "@emotion/styled";
import {CloseIcon} from "@web2/ap-icons";

import {AlertType, defaultAlertTimeout, IAlert} from "./add_remove_alert_action";

interface IProps extends IAlert {
    className?: string;
    removeAlert: (id: string) => void;
}

export const Alert = (props: IProps) => {
    useEffect(() => {
        setTimeout(() => props.removeAlert(props.id), props.ttl || defaultAlertTimeout);
    }, []);
    const theme = useTheme();

    return (
        <StyledAlert onClick={() => props.removeAlert(props.id)} style={{right: 0}} alertType={props.type}>
            <div css={textHolder} dangerouslySetInnerHTML={{__html: props.text}} />

            <div css={iconHolder}>
                <CloseIcon fillColor={theme.colors.text_color} size="1.4" />
            </div>
        </StyledAlert>
    );
};

interface IStyledALertProps {
    alertType: AlertType;
}

const initialOpacity = 0;
const finalOpacity = 1;
const transformUnit = "20rem";
const transition = "transform 0.2s ease-in-out, opacity 0.2s ease-in-out";

const StyledAlert = styled.div<IStyledALertProps>`
    padding: 2rem;
    max-width: 22rem;
    margin-bottom: 2rem;
    color: #fff;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    border-radius: ${(props) => props.theme.borders.border_radius_base};
    font-size: ${(props) => props.theme.fonts.font_size_small};
    background: ${(props) =>
        (props.alertType === AlertType.SUCCESS && props.theme.colors.brand_success) ||
        (props.alertType === AlertType.ERROR && props.theme.colors.brand_danger) ||
        (props.alertType === AlertType.INFO && props.theme.colors.brand_primary) ||
        (props.alertType === AlertType.WARNING && props.theme.colors.brand_primary)};

    &.slide-from-right-appear,
    &.slide-from-right-enter {
        opacity: ${initialOpacity};
        transform: translateX(${transformUnit});

        &.slide-from-right-appear-active,
        &.slide-from-right-enter-active {
            opacity: ${finalOpacity};
            transform: translateX(0);
            transition: ${transition};
        }
    }

    &.slide-from-right-exit {
        opacity: ${finalOpacity};
        transform: translateX(0);

        &.slide-from-right-exit-active {
            opacity: ${initialOpacity};
            transform: translateX(${transformUnit});
            transition: ${transition};
        }
    }
`;

const textHolder = (theme: Theme) => css`
    padding-right: 1.5rem;
    line-height: 1.8;

    a {
        color: ${theme.colors.text_color} !important;
    }
`;

const iconHolder = css`
    width: 1.4rem;
`;
